<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.administrators)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/administrators/new')">{{translate(locale.addNewAdministrator)}}</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchAdministrator)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="adminList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.userName)}}</md-table-head>
								<md-table-head>{{translate(locale.userUsername)}}</md-table-head>
								<md-table-head>{{translate(locale.createdDate)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(admin, index) in adminList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell>
									<div style="display: flex; flex-direction: row; align-items: center;">
										<img src="@/assets/img/default.png" style="width:40px;margin-right: 8px;"/>
										<span><b>{{admin.name}}</b><br>+{{admin.phone_number}}</span>
									</div>
								</md-table-cell>
								<md-table-cell><b>{{admin.username}}</b><br>
									<span v-if="admin.role == 'super-admin'">{{translate(locale.roleSuperAdmin)}}</span>
									<span v-if="admin.role == 'user'">{{translate(locale.roleUser)}}</span>
								</md-table-cell>
								<md-table-cell>
									<b>{{translate(config.datelify(admin.created_date))}}</b><br>({{(translate(config.getAge(admin.created_date)))}})
								</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="admin.status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="admin.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<!-- <md-button class="md-just-icon md-simple md-primary" @click="$router.push('/administrators/edit/' + admin.hash)">
										<md-icon>edit</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.edit)}}</md-tooltip>
									</md-button> -->

									<md-button class="md-just-icon md-simple md-warn" v-if="admin.status == 1" @click="onDisable(admin.hash)">
										<md-icon>hide_source</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disable)}}</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-success" v-if="admin.status == 0" @click="onEnable(admin.hash)">
										<md-icon>check_circle</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enable)}}</md-tooltip>
									</md-button>	
									<md-button class="md-just-icon md-simple md-danger" v-if="admin.status == 0" @click="onDelete(admin.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.deleteThis)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this manager ?" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" md-title="Are you sure want to disable this manager ?" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", role: "" },
				loadMore: false,
				adminList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/admin/search", {
					text: this.search.text,
					status: this.search.status,
					role: this.search.role,
					offset: more ? this.adminList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.adminList = more ? this.adminList.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/admin/admin/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/admin/admin/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/admin/admin/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Administrators/View.vue